<button mat-icon-button class="close-button" [mat-dialog-close]="">
  <mat-icon>clear</mat-icon>
</button>
<h2 mat-dialog-title>
  {{ 'case.change-patient-dialog.title' | translate | capitalize }}
</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col s12 m12 l6">
      <p style="font-weight: 500">
        {{ 'case.change-patient-dialog.choose-organization' | translate | capitalize }}
      </p>
      <mat-form-field appearance="outline">
        <mat-label></mat-label>
        <mat-select cdkFocusInitial (selectionChange)="onCareInstitutionChange($event)">
          @for (careInstitution of careInstitutions; track careInstitution) {
            <mat-option [value]="careInstitution"> {{ careInstitution.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (selectedCareInstitution && selectedCareInstitution.id !== '' && !departmentsLoading) {
        <p style="font-weight: 500">
          {{ 'case.change-patient-dialog.choose-department' | translate | capitalize }}
        </p>
        <mat-form-field appearance="outline">
          <mat-label></mat-label>
          <mat-select (selectionChange)="onDepartmentChange($event)">
            @for (department of selectedCareInstitution.departments; track department) {
              <mat-option [value]="department"> {{ department.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (departmentsLoading) {
        <mat-spinner diameter="30"></mat-spinner>
      }
    </div>
    @if (
      selectedCareInstitution &&
      selectedCareInstitution.id !== '' &&
      selectedDepartment &&
      selectedDepartment.id &&
      selectedDepartment.id !== '' &&
      patientMenuItems &&
      !patientsLoading
    ) {
      <div class="col s12 m12 l6">
        <p style="font-weight: 500">
          {{ 'case.change-patient-dialog.choose-patient' | translate | capitalize }}
        </p>
        @if (patientMenuItems.length > 0) {
          <app-select-list
            (selectedIdChange)="selectPatient($event)"
            [selectedId]="selectedPatientId"
            [data]="patientMenuItems">
          </app-select-list>
        }
        @if (patientMenuItems.length === 0) {
          <span> {{ 'case.change-patient-dialog.no-patients-found' | translate | capitalize }}</span>
        }
      </div>
    }
    <div class="col s12 m12 l6">
      @if (patientsLoading) {
        <mat-spinner style="margin: auto; padding-top: 20px" diameter="50"></mat-spinner>
      }
    </div>
    <div class="col s12">
      <br />
      <button mat-raised-button color="primary" style="float: right" [disabled]="!selectedPatientId" (click)="edit()">
        {{ 'general.actions.edit' | translate | capitalize }}
      </button>
    </div>
  </div>
</mat-dialog-content>
